import { useEffect, useState } from 'react';
import { getUser } from 'src/api/apis';
import { type User } from '../utils/type';
import { EMAIL_KEY, CURRENT_USER_ROLE, DEPARTMENT_OWN, CURRENT_USER_COMPANY } from './useLogin';

export default function useCurrentUser () {
  const [user, setUser] = useState<User | null>(null);

  const getCurrentUser = async (email: string) => {
    const response = await getUser({ email });
    if (response.data.user) {
      sessionStorage.setItem(CURRENT_USER_ROLE, response.data.user.role);
      sessionStorage.setItem(DEPARTMENT_OWN, response.data.user.department);
      sessionStorage.setItem(CURRENT_USER_COMPANY, response.data.user.company_id);
    }
    setUser(response.data.user);
  };

  useEffect(() => {
    const email = sessionStorage.getItem(EMAIL_KEY);
    if (email && user === null) {
      getCurrentUser(email);
    }
  }, [user]);

  return user;
}
